export default __webpack_public_path__ + "static/media/DOGE.733cd812.svg";